export default [
  {
    header: 'اصلی',
  },
  {
    title: 'dashboard',
    route: 'home',
    icon: 'PieChartIcon',
  },
  {
    header: 'کمپین ها',
  },
  {
    title: 'کمپین ها',
    icon: 'UsersIcon',
    children: [
      {
        title: 'کمپین آژانس ها',
        route: 'campaign',
      },
      {
        title: 'کمپین لندینگ ',
        route: 'campaign',
      },
      {
        title: 'کمپین شبکه اجتماعی ',
        route: 'campaign',
      },
      {
        title: 'کمپین محصولات ',
        route: 'campaign',
      },
      {
        title: 'سایر کمپین ها ',
        route: 'campaign',
      },
    ],
  },
  {
    title: 'اقامتگاه ها',

    icon: 'CodepenIcon',
    children: [
      {
        title: 'لیست اقامتگاه',
        route: 'residences',
      },
    ],
  },

  {
    title: 'تور ها',

    icon: 'CameraIcon',
    children: [
      {
        title: 'لیست تورها',
        route: 'tours',
      },
    ],
  },

  {
    title: 'تجربه ها',

    icon: 'UmbrellaIcon',
    children: [
      {
        title: 'لیست تجربه ها',
        route: 'events',
      },
    ],
  },

  {
    title: 'ترانسفر ها',

    icon: 'TruckIcon',
    children: [
      {
        title: 'لیست ترانسفر ها',
        route: 'cars',
      },
    ],
  },


  {
    header: 'رزور ها و گزارشات',
  },
  {
    title: 'رزرو های آنلاین',

    icon: 'FileTextIcon',
    children: [
      /*    {
            title: 'مشاهده همه رزروها',
            route: 'reservations',
          },*/
      {
        title: 'رزرو اقامتگاه',
        route: 'reservationSpace',
      },
      {
        title: 'رزرو تجربه',
        route: 'reservationEvent',
      },
      {
        title: 'رزرو تور',
        route: 'reservationTour',
      },
      {
        title: 'رزرو ترانسفر',
        route: 'reservationCar',
      },
    ],
  },

  /*  {
      title: 'رزرو های آفلاین',

      icon: 'WifiOffIcon',
      children: [
        {
          title: 'رزرو اقامتگاه',
          route: 'offlineSpace',
        },
        {
          title: 'رزرو تجربه',
          route: 'offlineEvent',
        },
        {
          title: 'رزرو تور',
          route: 'offlineTour',
        },
        {
          title: 'رزرو ترانسفر',
          route: 'offlineCar',
        },
      ],
    },*/

  {
    header: 'درخواست های رزرو',
  },
  {
    title: 'درخواست رزرو ها',

    icon: 'AwardIcon',
    children: [
      {
        title: 'رزرو اقامتگاه',
        route: 'orderSpace',
      },
      {
        title: 'رزرو تجربه',
        route: 'orderEvent',
      },
      {
        title: 'رزرو تور',
        route: 'orderTour',
      },
      {
        title: 'رزرو ترانسفر',
        route: 'orderCar',
      },
    ],
  },


/*
  {
    header: 'مدیریت',
  },
  {
    title: 'کاربران',
    icon: 'UsersIcon',
    children: [
      {
        title: 'لیست کاربران',
        route: 'users',
      },
      {
        title: 'ادمین ها',
        route: 'admins',
      },
      {
        title: 'میزبان ها',
        route: 'owners',
      },
      {
        title: 'مدیریت نقش ها',
        route: 'roles',
      },
    ],
  },

  {
    header: 'سایر خدمات',
  },
  {
    title: 'sms',
    icon: 'MailIcon',
    children: [
      {
        title: 'ارسال sms خدمات',
        route: 'adminSms',
      },
      {
        title: 'ارسال sms شخصی',
        route: 'smsMessage',
      },
    ],
  },

  {
    title: 'seo',
    icon: 'LayersIcon',
    children: [
      {
        title: 'خدمات سئو شهرها',
        route: 'seoCity',
      },
    ],
  },

  {
    title: 'کد تخفیف',
    icon: 'GiftIcon',
    children: [
      {
        title: 'کد تخفیف اقامتگاه',
        route: 'discountSpace',
      },
      {
        title: 'کد تخفیف تجربه',
        route: 'discountEvent',
      },
      {
        title: 'کد تخفیف تور',
        route: 'discountTour',
      },
      {
        title: 'کد تخفیف ترانسفر',
        route: 'discountCar',
      },
    ],
  },


  {
    header: 'سایر بخش ها',
  },
  {
    title: 'cities_provinces',
    icon: 'MapPinIcon',
    children: [
      {
        title: 'provinces',
        route: 'provinces',
      },
      {
        title: 'cities',
        route: 'cities',
      }
    ],
  },
  {
    title: 'کشور و پایتخت',
    icon: 'CompassIcon',
    children: [
      {
        title: 'کشور',
        route: 'countries',
      },
      {
        title: 'شهرها',
        route: 'capitals',
      }
    ],
  },
  {
    title: 'sliderAndPoster',
    route: 'slider',
    icon: 'ImageIcon',
    children: [
      {
        title: 'slider',
        route: 'slider',
      },
      {
        title: 'poster',
        route: 'poster',
      }
    ],
  },

  {
    title: 'خدمات روم تور',
    route: 'service',
    icon: 'FileTextIcon',
  },
  {
    title: 'خبرنامه',
    route: 'newsletters',
    icon: 'FileTextIcon',
  },
  {
    title: 'تماس با ما',
    route: 'contactus',
    icon: 'FileTextIcon',
  },
  {
    header: 'دیدگاه ها و نظرات',
  },
  {
    title: 'گفت و گوها',

    icon: 'TwitchIcon',
    children: [
      {
        title: 'آیتم های دیدگاه',
        route: 'commentsItems',
      },
      {
        title: 'دیدگاه ها',
        route: 'allComments',
      },
    ],
  },





  {
    header: ' تسویه حساب با میزبان',
  },
  {
    title: 'تسویه حساب میزبان',
    icon: 'DollarSignIcon',
    children: [
      {
        title: 'تسویه نشده  ',
        route: 'paymentNotHost',
      },
      {
        title: 'تسویه شده ',
        route: 'paymentHost',
      }
    ],
  },

  {
    title: 'رزور سایر خدمات',
    route: 'booking',
    icon: 'FileTextIcon',
  },*/



  {
    title: 'آمار و گزارشات',

    icon: 'BarChartIcon',
    children: [
      {
        title: 'آمار کلی ',
        route: 'statistics',
      },
      {
        title: 'آمار خدمات ',
        route: 'statisticsServices',
      },
      {
        title: 'آمار رزروها ',
        route: 'statisticsOrders',
      },
      {
        title: 'آمار رزروها 2',
        route: 'statisticsOrders2',
      },
      {
        title: 'آمار تراکنش ها ',
        route: 'statisticsTransactions',
      },
      {
        title: 'آمار تراکنش ها 2',
        route: 'statisticsTransactions2',
      },
      {
        title: 'آمار کاربران ',
        route: 'statisticsUsers',
      },
      {
        title: 'آمار اقامتگاه',
        route: 'statisticsResidences',
      },
      {
        title: 'آمار تجربه',
        route: 'statisticsExperiences',
      },
      {
        title: 'آمار تور',
        route: 'statisticsTours',
      },
      {
        title: 'آمار ترانسفر',
        route: 'statisticsCars',
      },
    ],
  },
 

]
